import { Flex } from '@utilitywarehouse/hearth-react';
import { useFormikContext } from 'formik';
import { useEffect } from 'react';

import { categories } from '@features/Cashback/Calculator/constants/categories';
import { createCalcOutput } from '@features/Cashback/Calculator/utils/createCalcOutput';
import { useThrottle } from '@hooks/useThrottle';

import { useCashbackCalculatorContext } from '../CalculatorProvider/CalculatorContext';
import { SpendType } from '../types';
import { Category } from './Category';
import { CategoryFields } from './types';
import { calcCategoryOutput } from './utils/calcCategoryOutput';

const SpendCategory = () => {
  const { setOutput } = useCashbackCalculatorContext();
  const { values, setFieldValue } = useFormikContext<CategoryFields>();

  const handleChange = (field: keyof CategoryFields, val: number) => {
    setFieldValue(field, val);
  };

  const handleCalcOutput = () => {
    const categoryOutput = calcCategoryOutput(values);
    setOutput(SpendType.Category, createCalcOutput(categoryOutput));
  };

  // use throttle here, since we're sliding values around. Otherwise
  // it might not calculate until values stop changing
  const debouncedHandleCalcOutput = useThrottle(handleCalcOutput, 250);

  useEffect(() => {
    debouncedHandleCalcOutput();
  }, [values, debouncedHandleCalcOutput]);

  return (
    <Flex spacing="xl" direction="column" className="SpendCategory__Container">
      {categories.map((category) => (
        <Category
          category={category}
          key={category.id}
          value={values[category.id]}
          step={5}
          max={category.max}
          onChange={(val) => handleChange(category.id, val)}
        />
      ))}
    </Flex>
  );
};

export { SpendCategory };
